import type { StudioPackageResolutionV1 } from "@enrein/shared-contracts";
import { sitePackageDisplayLabel } from "../../studio-shared/site-package-labels.js";
import { V10Btn } from "./V10Primitives.js";

export function V10PackageDowngradeCard({
  resolution,
  busy,
  onContinueWithBuilt,
  onEnrichProfile,
  onCopyClientIntakeLink,
  onRetryBuild,
}: {
  readonly resolution: StudioPackageResolutionV1;
  readonly busy: boolean;
  readonly onContinueWithBuilt: () => void;
  readonly onEnrichProfile: () => void;
  readonly onCopyClientIntakeLink: () => void;
  readonly onRetryBuild: () => void;
}) {
  if (!resolution.downgradeApplied) {
    return null;
  }

  const requestedLabel = sitePackageDisplayLabel(resolution.agencyRequestedSitePackageId);
  const builtLabel = sitePackageDisplayLabel(resolution.builtSitePackageId);

  return (
    <section className="v10-panel-block v10-package-downgrade-card" aria-label="Package downgrade recovery">
      <p className="v10-cl-kicker">Package downgrade</p>
      <p className="v10-validation">
        Requested: <strong>{requestedLabel}</strong> · Built: <strong>{builtLabel}</strong>
      </p>
      <p className="v10-muted">
        Auto-downgrade was applied because the profile did not meet {requestedLabel} requirements.{" "}
        {builtLabel} remains the built package — it is not treated as {requestedLabel}.
      </p>
      {resolution.reasons.length > 0 ? (
        <>
          <p className="v10-muted">Missing requirements:</p>
          <ul className="v10-validation-list">
            {resolution.reasons.map((reason) => (
              <li key={reason}>{reason}</li>
            ))}
          </ul>
        </>
      ) : null}
      {typeof resolution.richnessScore === "number" &&
      typeof resolution.minimumRichnessRequired === "number" ? (
        <p className="v10-muted">
          Richness score {resolution.richnessScore} — minimum {resolution.minimumRichnessRequired}{" "}
          required for {requestedLabel}.
        </p>
      ) : null}
      <p className="v10-muted">Safe options:</p>
      <div className="v10-hero-actions">
        <V10Btn variant="primary" disabled={busy} onClick={onContinueWithBuilt}>
          Continue with {builtLabel}
        </V10Btn>
        <V10Btn variant="gold" disabled={busy} onClick={onEnrichProfile}>
          Enrich profile for {requestedLabel}
        </V10Btn>
        <V10Btn variant="line" disabled={busy} onClick={onCopyClientIntakeLink}>
          Copy Client Intake Link
        </V10Btn>
        <V10Btn variant="line" disabled={busy} onClick={onRetryBuild}>
          Retry after evidence
        </V10Btn>
      </div>
    </section>
  );
}
